
export const tableHeaderConstants = {
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    age: "Age",
    experience: "Experience",
    positionApplied: "Position applied",
    dateOfApplication: "Date of application",
    status: "status of application",
}

export const sortHeaders = [
    tableHeaderConstants.positionApplied,
    tableHeaderConstants.dateOfApplication,
    tableHeaderConstants.experience
];